import Model from './abstracts/Model';
import { iSubscription } from '@/interfaces/subscriptions';

export class Subscription extends Model<iSubscription> {
    //
}

export default Subscription;
